import { memo, useContext } from "react";
import PropTypes from "prop-types";
import Separator from "app/pages/.shared/Separator";
import Total from "app/pages/.shared/PriceSummary/Total/Total";
import TotalNote from "app/pages/.shared/PriceSummary/TotalNote/TotalNote";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import appGlobalsContext from "app/AppGlobalsContext";
import { QuotationPriceDetailContainer } from "app/pages/Booking/Quotation/PriceDetails/QuotationPriceDetailContainer.jsx";
import "./PriceSummary.scss";

const QuotationPriceSummary = ({ hasChildren, total }) => {
	const { resolution } = useContext(appGlobalsContext);
	const isMobile = resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL;

	return (
		<>
			<div className="price-summary">
				{isMobile && (
					<>
						<QuotationPriceDetailContainer />
						<Separator design="full" margin="narrow" />
					</>
				)}

				{!isMobile && (
					<>
						<div className="price-summary__item">
							<Total total={total} taxesAndFeesIncluded />
						</div>

						<TotalNote showChildrenNote={hasChildren} />
					</>
				)}
			</div>
		</>
	);
};

QuotationPriceSummary.propTypes = {
	total: PropTypes.number,
	hasChildren: PropTypes.bool,
};

export default memo(QuotationPriceSummary);
